function editMinutes(time, minsToAdd, sub = false) {
  function D(J) { return (J < 10 ? '0' : '') + J; }
  const piece = time.split(':');
  let mins = (piece[0] * 60) + +piece[1] + +minsToAdd;

  if (sub) {
    mins = (piece[0] * 60) + +piece[1] + -minsToAdd;
  }

  return D(Math.floor((mins % (24 * 60)) / 60)) + ':' + D(mins % 60);
}

export default editMinutes;



// WEBPACK FOOTER //
// ./src/components/Resource/components/editMinutes.js